/* eslint-disable import/no-anonymous-default-export */
import { HTTP } from "api";

const basePath = "/account/";
//const basePath = "";

export default {
  addPassword(userId, code, password) {
    const p = {
      password,
      confirmPassword: password,
      code,
      userId: userId + "",
    };
    return HTTP.patch(basePath.concat("AddPassword"), p);
  },

  resetPassword(p) {
    return HTTP.post(basePath.concat("ResetPassword"), p);
  },

  askForSignIn(email) {
    const p = {
      email,
    };
    return HTTP.post(basePath.concat("AskForSignIn"), p);
    //return HTTP.get('../../mock/login.json', p);
  },

  login(email, password) {
    const p = {
      password,
      email,
    };
    return HTTP.post(basePath.concat("SignIn"), p);
    //return HTTP.get('../../mock/login.json', p);
  },

  logout() {
    const p = {};
    return HTTP.post(basePath.concat("SignOut"), p);
  },

  forgotPassword(email) {
    const p = {
      email: email,
    };
    return HTTP.post(basePath.concat("ForgotPassword"), p);
  },

  // richiesta password
  /********************
   * stesso giro di invitation!
   {
      "userId": 0,
      "code": "string",
      "newPassword": "string",
      "firstname": "string",
      "lastname": "string"
    }
   */
  // resetPassword(userId, code, newPassword, firstname, lastname) {
  //   const p = {
  //     userId: userId,
  //     code: code,
  //     newPassword: newPassword,
  //     firstname: firstname,
  //     lastname: lastname,
  //   };
  //   return HTTP.post(basePath.concat("ResetPassword"), p);
  // },

  // richiesta di signUp
  askForSignUp(email) {
    const p = {
      email,
    };
    return HTTP.post(basePath.concat("AskForSignUp"), p);
  },

  signUp(firstName, lastName, email, companyId, password) {
    const p = {
      firstName,
      lastName,
      email,
      companyId,
      password,
    };
    return HTTP.post(basePath.concat("SignUp"), p);
    //return HTTP.get('../../mock/login.json', p);
  },
  confirmEmail(userId, code) {
    const p = {
      code,
      userId,
    };
    return HTTP.post(basePath.concat("ConfirmEmail"), p);
  },

  startImpersonate(email) {
    email = encodeURIComponent(email);
    return HTTP.post(`/admin/impersonate?username=${email}`);
  },

  stopImpersonate(email) {
    return HTTP.post(`/admin/impersonate/stop-impersonation`);
  },

  refreshTraduzioni() {},

  getLanguages() {
    return HTTP.get(`/Globalization/GetLanguages`);
  },
};
